var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgRt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 525 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2421_5707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.929 82.4009H0C0 82.4009 16.2627 58.1679 71.6463 61.7455C127.034 65.3201 139.739 69.6872 139.739 69.6872C139.739 69.6872 142.279 41.8824 184.961 39.1031C227.644 36.3209 248.478 51.8139 248.478 51.8139C248.478 51.8139 241.362 22.8176 296.75 5.73673C352.133 -11.3441 390.244 13.6814 399.391 29.1716C399.391 29.1716 421.24 2.95451 455.793 14.8729C490.346 26.7884 489.328 54.5932 489.328 54.5932C489.328 54.5932 532.014 41.09 576.728 39.1031C621.951 37.1162 625 81.6056 625 81.6056L557.929 82.4009Z",
    fill: "#D1D048"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2421_5707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 525,
    height: 82,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRt);
export default __webpack_public_path__ + "static/media/bg-rt.edca05d72ee5072e5316a626d4983585.svg";
export { ForwardRef as ReactComponent };